var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sw-model-fix-slideshow" },
    [
      _c(
        "sw-carousel",
        {
          ref: "carousel",
          attrs: { "thumbnails-to-show": 4 },
          on: { slide: _vm.onSlide }
        },
        [
          _vm._l(_vm.slides, function(slide, index) {
            return _c(
              "slide",
              {
                key: "main-slide-" + index,
                staticClass: "sw-model-fix-slide",
                attrs: { index: index }
              },
              [
                slide.pictureUrl
                  ? _c(
                      "div",
                      { staticClass: "image-available" },
                      [
                        _c("zoom", {
                          staticClass: "zoom-container",
                          attrs: {
                            currentSlide: _vm.currentSlide,
                            index: index,
                            alt: slide.reasonTitle,
                            src: slide.pictureUrl
                          }
                        })
                      ],
                      1
                    )
                  : _c("div", { staticClass: "image-not-available" }, [
                      _c("div", [
                        _c("div", {
                          staticClass: "icon-camera sw--font-size-28"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "sw--font-size-16" }, [
                          _vm._v("No image available")
                        ])
                      ])
                    ])
              ]
            )
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "slider-title",
              attrs: { slot: "hooper-addons" },
              slot: "hooper-addons"
            },
            [
              _c("div", [
                _c("h6", [_vm._v("Part")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.modelName))])
              ])
            ]
          )
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "slider-bottom" }, [
        _c("h6", [_vm._v("Rejection issue")]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.currentReasonTitle))]),
        _vm._v(" "),
        _c("h6", [_vm._v("Rejection description")]),
        _vm._v(" "),
        _c("p", { domProps: { innerHTML: _vm._s(_vm.currentComment) } })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }